<div class="invalid-modal">
    <mapfre-modal [modalOptions]="invalidFileModalOptions" [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction()"
        (click)="hideOnClick($event)">
        <div class="modal-body mb-2 pb-4">
            <div class="margin-top mt16 text-center">
                <div>            
                    <img [src]="imgPath" alt="check icon"/>            
                </div>
                <h1 class="bigger-font-size mb-3 mt-3"> {{ 'Your file can’t be uploaded' | translate }}</h1>
                <div class="invalid-format margin-bottom mb2 margin-top lh-normal">{{ 'The current file format is not allowed. please use a JPG, PDF, GIF or PNG file'| translate }}</div>
            </div>
            <hr class="ma-hr-tag margin-top mt32 margin-bottom mb32">
            <div class="display-right margin-top mt24">
                <mapfre-button
                  (click)="hideModalAction()"
                  additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17"
                  >{{ "CLOSE" | translate }}
                </mapfre-button>
            </div>
        </div>
    </mapfre-modal>
</div>